import { Skeleton } from "@mui/material";
import React from "react";

const MessageSkeleton = () => {
  const data = [
    { _id: 1, type: "start" },
    { _id: 2, type: "end" },
    { _id: 3, type: "start" },
    { _id: 4, type: "start" },
    { _id: 5, type: "end" },
    { _id: 6, type: "start" },
    { _id: 7, type: "end" },
    { _id: 8, type: "start" },
    { _id: 9, type: "start" },
  ];
  return (
    <>
      {data.map(({ _id, type }) => {
        return (
          <div className={`d-flex flex-row justify-content-${type}`} key={_id}>
            {type === "start" ? (
              <Skeleton
                animation="wave"
                variant="circular"
                width={40}
                height={40}
              />
            ) : null}

            <div className="w-25">
              <Skeleton
                animation="wave"
                height={40}
                width="80%"
                style={{ marginBottom: 6, marginLeft: 4 }}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default MessageSkeleton;
